module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "logout"
    }
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/altai_logo_v2.png"),
      "alt": "logo"
    }
  })]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "loading",
      rawName: "v-loading:isLoading",
      arg: "isLoading"
    }],
    staticStyle: {
      "float": "right"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "sign-out-alt",
      "size": "lg"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "logout-text",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6db130a4","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logout.vue
// module id = lxCr
// module chunks = 1